var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconUserAccountPersonal = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M15.75 10.5C15.75 12.5707 14.0707 14.25 12 14.25C9.92925 14.25 8.25 12.5707 8.25 10.5C8.25 8.42925 9.92925 6.75 12 6.75C14.0707 6.75 15.75 8.42925 15.75 10.5ZM12 8.25C10.7573 8.25 9.75 9.25725 9.75 10.5C9.75 11.7428 10.7573 12.75 12 12.75C13.2428 12.75 14.25 11.7428 14.25 10.5C14.25 9.25725 13.2428 8.25 12 8.25Z", fill: "black" }),
            React.createElement("path", { d: "M21.75 12C21.75 17.3842 17.3842 21.75 12 21.75C6.61575 21.75 2.25 17.3842 2.25 12C2.25 6.61575 6.61575 2.25 12 2.25C17.3842 2.25 21.75 6.61575 21.75 12ZM20.25 12C20.25 7.44375 16.5562 3.75 12 3.75C7.44375 3.75 3.75 7.44375 3.75 12C3.75 14.8958 5.2425 17.4435 7.5 18.9158V17.8125C7.5 16.2735 8.65725 15 10.125 15H13.875C15.3427 15 16.5 16.2735 16.5 17.8125V18.9158C18.7575 17.4435 20.25 14.8958 20.25 12ZM15 19.6875V17.8125C15 17.0715 14.4803 16.5 13.875 16.5H10.125C9.51975 16.5 9 17.0715 9 17.8125V19.6875C9.93 20.0505 10.9417 20.25 12 20.25C13.0583 20.25 14.07 20.0505 15 19.6875Z", fill: "black" }))),
        alt: 'Icon UserAccountPersonal',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconUserAccountPersonal;
//# sourceMappingURL=index.js.map